import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import TopNav from "../containers/TopNav/TopNav";
import { Button, Switch, Collapse, Icon } from "@blueprintjs/core";
import Footer from "../containers/Footer";
import AppWrapper from "../containers/AppWrapper";
import { Translate } from "react-redux-i18n";
import prylpoolenPlaceholder from "../styles/images/prylpoolen-image.png";
import { fetchSharingBox, redirectToCheckout } from "../store/prypool_products/operations";
import { getSharingBox, isFetchingSessionId } from "../store/prypool_products/selectors";
import { SITE_URL } from "../config";

const SharingBox = (props) => {
  const boxId = props.match.params.boxId;
  const boxDetails = useSelector((state) => getSharingBox(state, boxId));
  const loading = useSelector(isFetchingSessionId);
  const dispatch = useDispatch();
  const [acceptedTerms, setSwitch] = useState(true);
  const [isOpen, changeCollapseState] = useState(false);
  useEffect(() => {
    dispatch(fetchSharingBox(boxId));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!boxDetails) return null;

  const termsAndConditionsChanged = (e) => {
    setSwitch(e.currentTarget.checked);
  }

  const toggleCollapsibleList = (e) => {
    changeCollapseState(!isOpen);
  }

  const goToCheckout = () => {
    const payload = {
      price_ids: [boxDetails.metadata.stripe_price_id],
      success_url: `${SITE_URL}/sharing-box-success/${boxId}`,
      cancel_url: `${SITE_URL}/sharing-box/${boxId}`,
    };
    if (boxDetails.metadata.discount.is_discount_enabled && boxDetails.metadata.discount.coupon_id) {
      payload["coupon_id"] = boxDetails.metadata.discount.coupon_id;
    }
    dispatch(redirectToCheckout(payload));
  };

  const price = boxDetails.metadata.discount.is_discount_enabled
    ? boxDetails.metadata.discount.discounted_price
    : boxDetails.metadata.price;

  return (
    <AppWrapper>
      <TopNav />
      <section className="gray-bg">
        <div className="main-container">
          <div className="content-wrapper">
            <div className="landing-box-feature prylpoolen">
              <div className="landing-box-copy">
                <h4>
                  <Translate value="prypool.price" price={price} />
                </h4>
                <h1>{boxDetails.title}</h1>
                <div className="mobile-landing-box-illustration">
                  <img src={prylpoolenPlaceholder} alt="ihopa Prylpoolen" />
                </div>
                <div className="landing-box-content">
                  <div dangerouslySetInnerHTML={{ __html: boxDetails.content }} />
                  <ul>
                    {boxDetails.metadata.sub_products.slice(0, 3).map((product) => (
                      <li key={product._id}>
                        <strong>{product.metadata.name}</strong>
                      </li>
                    ))}
                    <Collapse isOpen={isOpen} >
                      {boxDetails.metadata.sub_products.slice(3).map((product) => (
                        <li key={product._id}>
                          <strong>{product.metadata.name}</strong>
                        </li>
                      ))}
                    </Collapse>
                  </ul>
                  {!isOpen &&
                    <div className="sharing-box-more" onClick={toggleCollapsibleList} >
                      <Icon icon="more" iconSize="18" />
                    </div>
                  }
                  <hr />
                  <div className="sharing-box-address">
                    <strong>
                      <Translate value="prypool.address" />
                    </strong>
                    <div className="address-name">
                      <a
                        href={`https://www.google.com/maps/search/${boxDetails.metadata.sharing_box.metadata.address}`}
                        target="_blank"
                        rel="noopener noreferrer">
                        {boxDetails.metadata.sharing_box.metadata.address}
                      </a>
                    </div>
                  </div>
                </div>
                <Switch
                  defaultChecked={true}
                  label={
                    <span>
                      <Translate value="sign_up.read_and_accept" />{" "}
                      <a target="_blank" href="/privacy-policy"><Translate value="menu.privacy_policy" /></a> &amp;{" "}
                      <a target="_blank" href="/terms-of-use"><Translate value="menu.terms_of_use" /></a>
                    </span>
                  }
                  onChange={termsAndConditionsChanged}
                />
                <Button
                  intent="primary secondary-color"
                  className="cta sharing-box-cta"
                  fill={true}
                  onClick={goToCheckout}
                  loading={loading}
                  disabled={!acceptedTerms}
                >
                  <div className="button-price">
                    <Translate value="prypool.price_month" price={price} />
                  </div>
                  <div className="button-copy">
                    <Translate value="prypool.get_access" />
                  </div>
                </Button>
              </div>
              <div className="landing-box-illustration">
                <img src={prylpoolenPlaceholder} alt="ihopa Prylpoolen" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </AppWrapper>
  );
};

export default SharingBox;
